import React from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

import Action from '@components/Action'
import Edit from '@components/Icon/Edit'

function Actions ({ modalStore, profileStore }) {
  const { profile } = profileStore
  return (
    <div className='actions-wrapper'>
      <ul className='actions'>
        <li className='action'>
          <Action
            onClick={() => {
              modalStore.show({
                type: 'PROFILE_FORM',
                props: {
                  employee: profile,
                  onSaveSuccess: savedProfile => {
                    profileStore.getProfile(savedProfile.id)
                    modalStore.close()
                  }
                }
              })
            }}
          >
            <Edit />
            <span>Edit</span>
          </Action>
        </li>
      </ul>
    </div>
  )
}

Actions.propTypes = {
  modalStore: PropTypes.object,
  profileStore: PropTypes.object
}

export default inject('modalStore')(observer(Actions))
